!<!--  -->
<template>
  <div class="" style="">
   <div class="" style="padding:30px; background: #FFFFFF;
    box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
    border-radius: 10px;">
      <span
        style="
          margin-bottom: 20px;
          width: 71px;
          height: 23px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #343434;
        "
        >收货人</span
      >

      <div
        style="
          width: 147px;
          height: 40px;
          background: #ffffff;
          margin: 30px 0 20px 0;
          border: 1px solid #FF4D01;
          border-radius: 5px;
          text-align: center;
        "
      >
        <span
          @click="dialogVisible = true"
          class="pointer"
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FF4D01;
            line-height: 40px;
          "
          >新增收货地址</span
        >
      </div>
      <!-- 地址卡片 -->
      <div>
        <el-card
          v-for="(item, index) in addrList"
          :key="index"
          class="box-card card-hover"
          style="margin-bottom: 20px; border-radius: 10px"
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-right: 40px;
            "
          >
            <div style="">
              <!-- 行1 -->
              <div>
                <span
                  style="
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #343434;
                  "
                  >{{ item.name }}</span
                >
                <span
                  style="
                    margin-left: 20px;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #343434;
                  "
                  >{{ item.tel }}</span
                >
                <div
                  style="
                    margin-left: 20px;
                    display: inline-block;
                    height: 26px;
                    background: #f5ced3;
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                  "
                  v-if="item.isdefault"
                >
                  <span
                    style="
                      font-size: 14px;
                      font-family: PingFang SC;
                      font-weight: 500;
                      color: #FF4D01;
                      line-height: 26px;
                      padding: 0 8px 0 8px;
                    "
                    >默认地址</span
                  >
                </div>

                 <div
                  style="

                    display: inline-block;
                    height: 26px;
                    background: #f5ced3;
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                  "
                  v-if="item.tag"
                >
                  <span
                    style="
                      font-size: 14px;
                      font-family: PingFang SC;
                      font-weight: 500;
                      color: #FF4D01;
                      line-height: 26px;
                      padding: 0 8px 0 8px;
                    "
                    >{{item.tag}}</span
                  >
                </div>
              </div>

              <!-- 行2 -->
              <div style="margin-top: 20px">
                <span style="margin-right: 10px">{{ item.country }}</span>
                <span style="margin-right: 10px">{{ item.city }}</span>
                <span style="margin-right: 10px" v-if="item.area">{{
                  item.area
                }}</span>
                <span style="margin-right: 10px">{{ item.address }}</span>
              </div>
            </div>

            <div>
              <span @click="setAsDefault(item)" v-if="!item.isDefault"
                style="
                  border-right: 1px solid #e7e7e7;
                  padding-right: 20px;
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #FF4D01;
                "
                class="pointer"
                >设为默认</span
              >
              <span @click="edit(item)"
                style="
                  border-right: 1px solid #e7e7e7;
                  padding: 0 20px;
                  font-size: 16px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #FF4D01;
                "
                class="pointer"
                >编辑</span
              >
              <span @click="confirmDelete(item.id)" style="color: #999; padding: 0 20px" class="pointer"
                >删除</span
              >
            </div>
          </div>
        </el-card>
      </div>

      <!-- 新增弹窗 -->
      <el-dialog
      :before-close="handleClose"
        custom-class="class1"
        style="border-radius: 20px"
        title="新增地址"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <div style="width: 85%; margin: 0 auto; max-width: 500px">
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6">
                <div class="grid-content bg-purple">
                    <span style="line-height: 40px">联系人</span>
              </div>
            </el-col>
            <el-col :span="18">
                <div class="grid-content bg-purple">
                  <el-input v-model="submitForm.name" placeholder="请输入联系人"></el-input>
                </div
            ></el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">联系方式</span>
              </div></el-col
            >
            <el-col :span="18"
              >
                <div class="grid-content bg-purple">
                  <el-input v-model="submitForm.tel" placeholder="请输入联系方式"></el-input>
                </div
            ></el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">联系地址</span>
              </div></el-col
            >
            <el-col :span="18">
              <div class="grid-content bg-purple">
                <el-cascader :options="citylist" placeholder="请选择收货地址"
                 v-model="value" clearable   @change="handleChange"
                 :props="props">
                </el-cascader>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <div
                  style="line-height: 40px; width: 10px; height: 10px"
                ></div></div
            ></el-col>
            <el-col :span="18"
              ><div class="grid-content bg-purple">
                <el-input v-model="submitForm.address"  type="textarea" rows="2" placeholder="请输入详细地址"></el-input></div
            ></el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">标签</span>
              </div></el-col
            >
            <el-col :span="18"
              ><div class="grid-content bg-purple"><el-input v-model="submitForm.tag" placeholder="请输入标签"></el-input></div
            ></el-col>
          </el-row>

          <div style="width: 300px; margin: 0 auto; text-align: center">
            <div style="display: flex; justify-content: center">
              <el-checkbox
                text-color="#FF4D01"
                v-model="submitForm.isdefault"
                style="margin-right: 10px"
              ></el-checkbox>
              <span style="display: block; margin-bottom: 20px">
                设置为默认地址
              </span>
            </div>
            <el-button @click="addAddr"
              style="
                background: #FF4D01;
                border: 1px solid #FF4D01;
                border-radius: 5px;
                color: #fff;
              "
              >{{this.submitForm.id ? '修改' : '新增'}}</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
        props:{
            value:'namec',
            label:'namec',
        },
        value:'',
      citylist: [

      ], // 省市区列表
      submitForm: {
          "address": "",
          "area": "",
          "city": "",
          "country": "",
          "customerid": '',
          "id": '',
          "isdefault": false,
          "name": "",
          "tag": "",
          "tel": ""
        },
      dialogVisible: false,
      addrList: [],
      value:["","",""]
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    // 校验
      very(){

          if(!this.submitForm.name){
                this.$message.info('联系人不能为空！')
                return false
          }
          if (!(/^1[3456789]\d{9}$/.test(this.submitForm.tel))){
					        this.$message.info("手机号码有误，请重填");
                    return false
                }

           if(!this.submitForm.country){
                this.$message.info('国家不能为空！')
                return false
          }
           if(!this.submitForm.city){
                this.$message.info('联系地址不能为空！')
                return false
          }
           if(!this.submitForm.address){
                this.$message.info('详细地址不能为空！')
                return false
          }
           if(this.submitForm.tag){
             if(this.submitForm.tag.length > 5){
                this.$message.info('标签长度不能超过五个字符')
                return false
             }

          }


          return true
      },
    // 设置默认
      setAsDefault(item){
          let form  = new FormData()
          form.append('addressId',item.id)
          this.axios.post(`/customer/updateAddressDefault`, form)
          .then((res) => {
           if (res.data.code == 200) {
             this.getList()
          } else {
           this.$message.info(res.data.message);
           this.getList()
           }
          }) .catch((res) => {
          console.log(res);
          });

      },
      resetData(){
           for(let key in this.submitForm){
                     this.submitForm[key] = ""
                 }

              this.value = ["","",""]

      },
      handleClose(done) {
              this.dialogVisible = false
              this.resetData()

      },

      edit(item){
          console.log(item)
        //    this.submitForm.country = item.country
        // this.value = []
            this.value = ["","",""]
          this.value[0] = item.country
          this.value[1] = item.city
          this.value[2] = item.area
          // console.log(this.value)
           this.submitForm.name = item.name
           this.submitForm.country = item.country
           this.submitForm.city = item.city
           this.submitForm.area = item.area
           this.submitForm.id = item.id
           this.submitForm.tel = item.tel
        //    this.submitForm.city = item.city
            this.submitForm.address = item.address
           this.submitForm.tag = item.tag
           this.submitForm.isdefault = item.isdefault
          this.dialogVisible = true
      },
      // 获取目的国地址列表
      getPopList(){



          this.axios.post('/filedata/findThirdLevelAddress')
          .then(res => {

                    console.log(res)
                    if (res.data.code == 200) {
                      this.citylist = res.data.datas
                    }else{
                                this.$message.info('服务器繁忙')
                            }

                  }).catch(res => {
                            this.$message.info('服务器繁忙')
                  })
      },

    handleChange(value) {
      console.log(value);
      this.submitForm.country = value[0]
      this.submitForm.city = value[1]
      this.submitForm.area = value[2]
    },
    confirmDelete(id) {



        this.$confirm('此操作将删除该地址, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

              let user = localStorage.getItem("Authorization_lineSupplier")
             user = JSON.parse(user);

                 this.axios
        .post(
          "/customer/delAddress/" + id,
          {}, {
            headers: {

              token: user.token,
            },

				}
        )
        .then((res) => {
         if(res.data.code != 200){
              this.$message("服务器繁忙");
              return
         }
          this.$message("删除成功");
          this.getList()
        })
        .catch((res) => {
          this.$message("服务器繁忙");
        });





        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

    },

    addAddr() {

        // console.log(this.submitForm.id)
        if(!this.very()){
          return
        }

         let user = localStorage.getItem("Authorization_lineSupplier")
         user = JSON.parse(user);
        // 新增
        this.submitForm.customerid = user.customerid;

      this.axios
        .post("/customer/addOrUpdateConsigner", this.submitForm)
        .then((res) => {
          console.log(res);
          if (res.data.code != 200) {
               this.$message.info(res.data.message);
            return
          }

             this.$message.info( this.submitForm.id ? '修改成功!' : '新增成功!');
              this.getList()
             this.dialogVisible = false
            this.resetData()


        })
        .catch((res) => {
          console.log(res);
        });
    },
    getList() {
      let user = localStorage.getItem("Authorization_lineSupplier")
      user = JSON.parse(user);

      this.axios
        .get("/customer/addressListForConsigner/" + user.customerid )
        .then((res) => {
          console.log(res);
          this.addList = res.datas;
          if (res.data.code != 200) {
            this.$message.info("服务器繁忙...");
            return;
          }
           this.addrList = res.data.datas
          // this.addrList = res.data.datas.map((item, index) => {
          //   return {
          //       id: item.id,
          //     name: item.name,
          //     tel: item.tel,
          //     isDefault: item.isdefault,
          //     country: item.country,
          //     city: item.city,
          //     area: item.area,
          //     address: item.address,
          //     tag: item.tag,
          //   };
          // });
          console.log(this.addrList);
        })
        .catch((res) => {
          console.log("falss");
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //   获取地址列表
    this.getList();
    // 获取目的国列表
    this.getPopList()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style  scoped>
/* @import './../../../assets/css/free.css';
@import url('./../../../assets/css/free.css');  */
.card-hover:hover {
  border: 1px solid #FF4D01;
}
.class1 {
  border-radius: 20px;
}
.pointer {
  cursor: pointer;
}
/* //@import url(); 引入公共css类 */
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/ReceivePage.vue